(function () {
  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Shopify && theme.Shopify.formatMoney) {
      return theme.Shopify.formatMoney(cents, theme.moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function parseNumber(value) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function parsePriceToCents(price) {
    if (typeof price === 'number') {
      return Math.round(price);
    }

    var parsed = parseFloat(String(price).replace(/[^0-9.-]/g, ''));
    return Number.isNaN(parsed) ? 0 : Math.round(parsed * 100);
  }

  function ProductVolumePricing(root) {
    this.root = root;
    this.tiersContainer = root.querySelector('.product-volume-pricing__tiers');
    this.tiers = Array.from(root.querySelectorAll('.product-volume-pricing__tier'));
    this.inputs = Array.from(root.querySelectorAll('.product-volume-pricing__input'));
    this.qtyInput = root.querySelector('[data-qty-input]');
    this.summary = root.querySelector('[data-pricing-summary]');
    this.summaryCompare = root.querySelector('[data-summary-compare]');
    this.summaryTotal = root.querySelector('[data-summary-total]');
    this.summarySavings = root.querySelector('[data-summary-savings]');
    this.basePrice = parseNumber(root.dataset.basePrice);
    this.comparePrice = parseNumber(root.dataset.comparePrice);
    this.savingsLabel = root.dataset.savingsLabel || 'You save';
    this.eachLabel = root.dataset.eachLabel || 'each';
    this.standardPriceLabel = root.dataset.standardPriceLabel || 'Standard Price';
    this.popularLabel = root.dataset.popularLabel || 'Most popular ⚡';
    this.tierInputName = root.dataset.tierInputName || 'volume-pricing-tier';
    this.defaultTierMinQty = parseNumber(root.dataset.defaultTierMinQty) || 15;
    this.popularTierMinQty = parseNumber(root.dataset.popularTierMinQty) || 30;
    this.syncing = false;

    this.bindEvents();
    this.syncFromQuantity(parseNumber(this.qtyInput ? this.qtyInput.value : root.dataset.initialQty || 1), true);
  }

  ProductVolumePricing.prototype.getConfig = function () {
    if (this._config !== undefined) {
      return this._config;
    }

    var script = this.root.querySelector('[data-quantity-pricing-metafield]');

    if (!script) {
      this._config = null;
      return this._config;
    }

    try {
      this._config = JSON.parse(script.textContent);
    } catch (error) {
      this._config = null;
    }

    return this._config;
  };

  ProductVolumePricing.prototype.getGroupForVariant = function (variantId) {
    var config = this.getConfig();

    if (!config || !Array.isArray(config.groups)) {
      return null;
    }

    var gid = 'gid://shopify/ProductVariant/' + variantId;

    for (var i = 0; i < config.groups.length; i++) {
      var group = config.groups[i];

      if (!group || !Array.isArray(group.variantIds)) {
        continue;
      }

      if (group.variantIds.indexOf(gid) !== -1) {
        return group;
      }
    }

    return null;
  };

  ProductVolumePricing.prototype.getTierLabel = function (minQty, maxQty) {
    if (!maxQty) {
      return 'Buy ' + minQty + '+';
    }

    return 'Buy ' + minQty + ' - ' + maxQty;
  };

  ProductVolumePricing.prototype.refreshTierElements = function () {
    this.tiers = Array.from(this.root.querySelectorAll('.product-volume-pricing__tier'));
    this.inputs = Array.from(this.root.querySelectorAll('.product-volume-pricing__input'));
  };

  ProductVolumePricing.prototype.renderTiers = function (group) {
    if (!this.tiersContainer || !group || !Array.isArray(group.tiers)) {
      return;
    }

    var self = this;
    var basePriceCents = parsePriceToCents(group.basePrice);
    var tierInputName = this.tierInputName;
    var tiersHtml = '';

    group.tiers.forEach(function (tier, index) {
      var minQty = parseNumber(tier.minQuantity) || 1;
      var maxQty = tier.maxQuantity == null ? 0 : parseNumber(tier.maxQuantity);
      var unitPriceCents = parsePriceToCents(tier.unitPrice);
      var savingsPerUnit = Math.max(0, basePriceCents - unitPriceCents);
      var isBaseTier = savingsPerUnit === 0;
      var isPopular = minQty === self.popularTierMinQty;
      var isActive = minQty === self.defaultTierMinQty;
      var tierLabel = self.getTierLabel(minQty, maxQty);
      var unitPriceText = isBaseTier
        ? formatMoney(unitPriceCents)
        : formatMoney(unitPriceCents) + ' ' + self.eachLabel;
      var sublabelHtml = '';

      if (isBaseTier) {
        sublabelHtml = '<p class="product-volume-pricing__sublabel">' + self.standardPriceLabel + '</p>';
      } else if (savingsPerUnit > 0) {
        sublabelHtml = '<p class="product-volume-pricing__sublabel">Get <span class="product-volume-pricing__sublabel-strong">' +
          formatMoney(savingsPerUnit) + ' off</span> each</p>';
      }

      tiersHtml += '<div class="product-volume-pricing__tier' +
        (isActive ? ' is-active' : '') +
        (isPopular ? ' product-volume-pricing__tier--popular' : '') +
        '">' +
        (isPopular ? '<div class="product-volume-pricing__popular-banner">' + self.popularLabel + '</div>' : '') +
        '<label class="product-volume-pricing__tier-body">' +
        '<input type="radio" class="product-volume-pricing__input visually-hidden" ' +
        'name="' + tierInputName + '" value="' + (index + 1) + '" ' +
        'data-tier-min="' + minQty + '" data-tier-max="' + maxQty + '" ' +
        'data-tier-unit-price="' + unitPriceCents + '" data-tier-discount="' + savingsPerUnit + '" ' +
        (isActive ? 'checked' : '') + '>' +
        '<div class="product-volume-pricing__tier-left">' +
        '<span class="product-volume-pricing__radio" aria-hidden="true"></span>' +
        '<span class="product-volume-pricing__tier-label">' + tierLabel + '</span>' +
        '</div>' +
        '<div class="product-volume-pricing__tier-right">' +
        '<p class="product-volume-pricing__unit-price">' + unitPriceText + '</p>' +
        sublabelHtml +
        '</div>' +
        '</label>' +
        '</div>';
    });

    this.tiersContainer.innerHTML = tiersHtml;
    this.refreshTierElements();
    this.bindTierInputEvents();
  };

  ProductVolumePricing.prototype.bindTierInputEvents = function () {
    var self = this;

    this.inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (self.syncing) {
          return;
        }

        var minQty = parseNumber(input.dataset.tierMin) || 1;
        self.setQuantity(minQty, false);
        self.applyTierInput(input);
        self.updateSummary();
      });
    });
  };

  ProductVolumePricing.prototype.bindEvents = function () {
    var self = this;

    this.bindTierInputEvents();

    if (!this.qtyInput) {
      return;
    }

    this.qtyInput.addEventListener('change', function () {
      self.syncFromQuantity(parseNumber(self.qtyInput.value), false);
    });

    this.qtyInput.addEventListener('input', function () {
      self.syncFromQuantity(parseNumber(self.qtyInput.value), false);
    });

    var decreaseBtn = this.root.querySelector('[data-qty-decrease]');
    var increaseBtn = this.root.querySelector('[data-qty-increase]');

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function () {
        var nextQty = Math.max(1, parseNumber(self.qtyInput.value) - 1);
        self.setQuantity(nextQty, true);
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', function () {
        var nextQty = parseNumber(self.qtyInput.value) + 1;
        self.setQuantity(nextQty, true);
      });
    }

    this.root.addEventListener('on:variant:change', function (evt) {
      if (!evt.detail || !evt.detail.variant) {
        return;
      }

      self.updateVariantPricing(evt.detail.variant);
    });

    document.addEventListener('on:variant:change', function (evt) {
      if (!evt.detail || !evt.detail.variant) {
        return;
      }

      if (!self.root.isConnected) {
        return;
      }

      var section = self.root.closest('[data-section-id]');
      if (section && evt.detail.sectionId && section.dataset.sectionId !== String(evt.detail.sectionId)) {
        return;
      }

      self.updateVariantPricing(evt.detail.variant);
    });
  };

  ProductVolumePricing.prototype.updateVariantPricing = function (variant) {
    var group = this.getGroupForVariant(variant.id);
    var currentQty = parseNumber(this.qtyInput ? this.qtyInput.value : this.root.dataset.initialQty || 1);

    if (group) {
      this.basePrice = parsePriceToCents(group.basePrice);
      this.comparePrice = this.basePrice;
      this.renderTiers(group);
    } else {
      this.basePrice = parseNumber(variant.price);
      this.comparePrice = parseNumber(variant.compare_at_price) || this.basePrice;

      if (this.comparePrice < this.basePrice) {
        this.comparePrice = this.basePrice;
      }

      if (this.tiersContainer) {
        this.tiersContainer.innerHTML = '';
        this.refreshTierElements();
      }
    }

    this.root.dataset.basePrice = this.basePrice;
    this.root.dataset.comparePrice = this.comparePrice;
    this.syncFromQuantity(currentQty, true);
  };

  ProductVolumePricing.prototype.getTierForQuantity = function (quantity) {
    var matchedInput = null;
    var matchedMin = -1;

    this.inputs.forEach(function (input) {
      var minQty = parseNumber(input.dataset.tierMin) || 1;
      var maxQty = parseNumber(input.dataset.tierMax);
      var inRange = quantity >= minQty && (maxQty === 0 || quantity <= maxQty);

      if (inRange && minQty >= matchedMin) {
        matchedInput = input;
        matchedMin = minQty;
      }
    });

    if (!matchedInput) {
      this.inputs.forEach(function (input) {
        var minQty = parseNumber(input.dataset.tierMin) || 1;
        if (quantity >= minQty && minQty >= matchedMin) {
          matchedInput = input;
          matchedMin = minQty;
        }
      });
    }

    return matchedInput;
  };

  ProductVolumePricing.prototype.applyTierInput = function (input) {
    this.tiers.forEach(function (tier) {
      tier.classList.toggle('is-active', tier.contains(input));
    });

    this.syncing = true;
    input.checked = true;
    this.syncing = false;
  };

  ProductVolumePricing.prototype.setQuantity = function (quantity, updateTier) {
    if (!this.qtyInput) {
      return;
    }

    var safeQty = Math.max(1, quantity);
    this.qtyInput.value = safeQty;

    if (updateTier) {
      this.syncFromQuantity(safeQty, false);
    }
  };

  ProductVolumePricing.prototype.syncFromQuantity = function (quantity, isInit) {
    var safeQty = Math.max(1, quantity);
    var matchedInput = this.getTierForQuantity(safeQty);

    if (!matchedInput && this.inputs.length) {
      matchedInput = this.inputs[0];
    }

    if (matchedInput) {
      this.applyTierInput(matchedInput);
    }

    if (this.qtyInput && parseNumber(this.qtyInput.value) !== safeQty) {
      this.qtyInput.value = safeQty;
    }

    this.updateSummary();

    if (!isInit && this.qtyInput) {
      this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  ProductVolumePricing.prototype.getActiveUnitPrice = function () {
    var activeInput = this.root.querySelector('.product-volume-pricing__input:checked');

    if (activeInput && activeInput.dataset.tierUnitPrice) {
      return parseNumber(activeInput.dataset.tierUnitPrice);
    }

    return this.basePrice;
  };

  ProductVolumePricing.prototype.updateSummary = function () {
    if (!this.summary || !this.qtyInput) {
      return;
    }

    var quantity = Math.max(1, parseNumber(this.qtyInput.value));
    var unitPrice = this.getActiveUnitPrice();
    var compareUnit = this.comparePrice > 0 ? this.comparePrice : this.basePrice;
    var compareSubtotal = compareUnit * quantity;
    var currentSubtotal = unitPrice * quantity;
    var savings = Math.max(0, compareSubtotal - currentSubtotal);

    if (savings > 0 || unitPrice !== compareUnit) {
      this.summary.hidden = false;
      this.summaryCompare.textContent = formatMoney(compareSubtotal);
      this.summaryTotal.textContent = formatMoney(currentSubtotal);

      if (savings > 0) {
        this.summarySavings.hidden = false;
        this.summarySavings.innerHTML = this.savingsLabel + ' <strong>' + formatMoney(savings) + '</strong>';
      } else {
        this.summarySavings.hidden = true;
        this.summarySavings.textContent = '';
      }
    } else {
      this.summary.hidden = true;
    }
  };

  function mountVolumePricingAtc() {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    document.querySelectorAll('[data-product-volume-pricing]').forEach(function (root) {
      var purchaseRow = root.querySelector('.product-volume-pricing__purchase-row');
      var form = root.closest('form');

      if (!purchaseRow || !form) {
        return;
      }

      var atcHome = form.querySelector('[data-volume-atc-home]');
      var atcButton = atcHome && atcHome.querySelector('[data-add-to-cart]');

      if (!atcHome || !atcButton) {
        return;
      }

      if (isMobile) {
        if (atcButton.parentElement !== purchaseRow) {
          purchaseRow.appendChild(atcButton);
        }
      } else if (atcButton.parentElement !== atcHome) {
        atcHome.appendChild(atcButton);
      }
    });
  }

  function initProductVolumePricing() {
    document.querySelectorAll('[data-product-volume-pricing]').forEach(function (root) {
      if (root.dataset.volumePricingInit === 'true') {
        return;
      }

      root.dataset.volumePricingInit = 'true';
      root.dataset.savingsLabel = root.dataset.savingsLabel || 'You save';
      new ProductVolumePricing(root);
    });
  }

  function bootProductVolumePricing() {
    initProductVolumePricing();
    mountVolumePricingAtc();
  }

  document.addEventListener('DOMContentLoaded', bootProductVolumePricing);
  document.addEventListener('shopify:section:load', bootProductVolumePricing);
  window.addEventListener('resize', mountVolumePricingAtc);
})();
